import { getCasinoGameImgIdentifier, getRatioForLayout, isDemoModeAvailable } from '../../util/gaming'
import Image from 'next/legacy/image'
import Tag from '../core/Tag'
import FadeIn from '../animation/FadeIn'
import useTranslation from 'next-translate/useTranslation'
import { CmsCompetitionDTO } from '@arland-bmnext/webapps-api-data'

export const CasinoGamesListItem = ({
  casinoGame,
  onCasinoGameClick,
  imgAspectRatio: imgAspectRation,
  demoModeActive = false,
  layout = 'grid',
}: {
  casinoGame: CmsCompetitionDTO
  onCasinoGameClick: (gameId: number, gameName: string) => void
  imgAspectRatio?: string
  demoModeActive?: boolean
  layout?: 'grid' | 'cards'
}) => {
  const { t } = useTranslation('casino')
  const imgIdentifier = getCasinoGameImgIdentifier(casinoGame, getRatioForLayout(layout))
  const demoUnavailable = demoModeActive && !isDemoModeAvailable(casinoGame)

  return (
    <div className="casino-games-list-item flex justify-center items-center relative w-full h-full">
      <div
        className={`casino-games-list-item-inner flex flex-col relative w-full h-full overflow-hidden shadow-sm ${
          demoUnavailable ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
        onClick={() => onCasinoGameClick(casinoGame.id, casinoGame.name)}
      >
        <div
          className={`casino-games-list-item-img flex w-full relative rounded-md overflow-hidden ${imgAspectRation}`}
        >
          {imgIdentifier ? (
            <Image
              src={imgIdentifier}
              layout="fill"
              objectFit="cover"
              alt={casinoGame.name}
              className={'transition rounded-md hover:scale-110'}
              placeholder="blur"
              blurDataURL={imgIdentifier}
            />
          ) : (
            <div className="absolute flex justify-center items-center h-full w-full bg-gray-500 rounded-md"></div>
          )}

          {demoUnavailable && (
            <FadeIn>
              <div className="casino-games-list-item-demo-unavailable absolute w-full h-full rounded-md p-4 bg-black bg-opacity-70 flex justify-center items-center">
                <Tag>{t('Casino.demoUnavailable')}</Tag>
              </div>
            </FadeIn>
          )}
        </div>

        <div className="casino-games-list-item-details w-full flex flex-col space-y-1 justify-end items-start py-2 overflow-hidden">
          <div className="casino-games-list-item-details-name flex w-full overflow-hidden font-bold text-sm leading-none hover:underline">
            <span className="whitespace-nowrap overflow-hidden overflow-ellipsis">{casinoGame.name}</span>
          </div>
          <span className="casino-games-list-item-details-provider text-xs opacity-50 leading-none">
            {casinoGame.providerName}
          </span>
        </div>
      </div>
    </div>
  )
}
